import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=bd327476&scoped=true"
import script from "./SaveIcon.vue?vue&type=script&lang=js"
export * from "./SaveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd327476",
  null
  
)

export default component.exports